export enum HomographyActions {
  UPDATE_LPR_CONTEXT_POINTS = 'UPDATE_LPR_CONTEXT_POINTS',
  UPDATE_LPR_POINTS = 'UPDATE_LPR_POINTS',
  UPDATE_NIGHT_LPR_CONTEXT_POINTS = 'UPDATE_NIGHT_LPR_CONTEXT_POINTS',
  UPDATE_NIGHT_LPR_POINTS = 'UPDATE_NIGHT_LPR_POINTS',
  UPDATE_MAP_CONTEXT_POINTS = 'UPDATE_MAP_CONTEXT_POINTS',
  UPDATE_MAP_POINTS = 'UPDATE_MAP_POINTS',
  UPDATE_MAP_MARKERS = 'UPDATE_MAP_MARKERS',
  DELETE_MAP_MARKERS = 'DELETE_MAP_MARKERS',
  CALCULATING_HOMOGRAPHY = 'CALCULATING_HOMOGRAPHY',
  LPR_MODIFIED = 'LPR_MODIFIED',
  MAP_MODIFIED = 'MAP_MODIFIED',
  NIGHT_LPR_MODIFIED = 'NIGHT_LPR_MODIFIED',
  UPDATE_CALCULATED_HOMOGRAPHY = 'UPDATE_CALCULATED_HOMOGRAPHY',
  DELETE_CALCULATED_HOMOGRAPHY = 'DELETE_CALCULATED_HOMOGRAPHY',
}

export enum HomographyCamera {
  CONTEXT = 'CONTEXT',
  LPR = 'LPR',
  MAP = 'MAP',
}
